<template>
    <v-card :style="{'border-radius':'5px','border':'1px solid'+$store.getters.getColorPalette().panelBorderColorCode}" flat  :dark="$store.getters.getColorPalette().isDark">
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" v-on:close="showDismissibleAlert=false" :info="info" />
        <v-data-table
            :headers="headers"
            :items="items"
            item-key="item_code"
            :search="search"
            :loading="loading"
            loading-text="Loading... Please wait"
            :dark="$store.getters.getColorPalette().isDark"
            :single-expand="true"
          show-expand
          :expanded.sync="expanded"
        >
            <template v-slot:top>
            <v-toolbar
                flat
                :dark="$store.getters.getColorPalette().isDark"
            >
            <v-toolbar-title>{{ $store.getters.getTextMap().item_code }}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <CreateItemCodeModal v-on:update="getItemCodes" v-if="$store.state.user && $store.state.settingMode && $store.getters.getAccessByLevels(['engineeraccess'])" />
                <v-icon class="ml-2" small :color="$store.getters.getColorPalette().accentCode" @click="getItemCodes">mdi-refresh</v-icon>
            </v-toolbar>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <AddItemStockModal :item_code="item.item_code" v-on:update="getItemCodes"/>
           
          </td>
        </template>
          
    </v-data-table>
  </v-card>
</template>
<script>
import CreateItemCodeModal from '@/components/modals/derived/CreateItemCodeModal'
import AddItemStockModal from '@/components/modals/manufacturing/stores/AddItemStockModal'
import axios from 'axios'
import InfoAlert from '@/components/InfoAlert'
export default {
    name:'ItemCodeTable',
    components:{
        CreateItemCodeModal,
        AddItemStockModal,
        InfoAlert
    },
    mounted(){
      this.getItemCodes()
    },
    data(){
        return {
            search:'',
            loading:false,
            info:'',
            showDismissibleAlert:false,
            items:[],
            expanded: [],
            headers: [
                {
                    text: 'Item Code',
                    align: 'start',
                    filterable: false,
                    value: 'item_code',
                    class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName
                },
                { text: 'Name', value: 'item_name', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                { text: 'Material', value: 'material', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                { text: 'Material Group', value: 'material_group', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                { text: 'Material Desc', value: 'material_desc', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                { text: 'UOM', value: 'uom', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                { text: 'Available Stock', value: 'available_stock', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
            ],
        }
    },
    computed:{


    },
    methods:{
        getItemCodes(){
            this.loading=true
            axios.get(this.$store.state.api+'itemCodes',{headers: {Authorization: 'Bearer '+ this.$store.state.jwt}})
            .then(response=>{
                if(response.data.status=='success'){
                    this.items=response.data.data
                }else{
                    this.info=response.data.msg
                    this.showDismissibleAlert=true
                }
                this.loading=false
            }).catch(err=>{
                this.loading=false
                this.info=err
                this.showDismissibleAlert=true 
            })
            
        }
    },
}
</script>
